import React from "react";
import styles from "./PublicationPageHeroBlock.module.scss";
import classNames from "classnames";
import { ReactComponentPropsBase } from "../../../base-props/ReactComponentPropsBase";
import MultiMediaBlock from "../MultiMediaBlock/MultiMediaBlock";
import IconMS from "src/components/utils/IconMS/IconMS";
import { ImageProps } from "../../base/Image/Image";
import useHeroBackground from "src/utils/use-hero-background/useHeroBackground";
import { useTheme } from "src/utils/useTheme";

export interface PublicationPageHeroBlockProps extends ReactComponentPropsBase {
  byline?: string;
  heading: string;
  image?: ImageProps;
  mediaText?: string;
  publishDate?: string;
  publishedOrUpdatedHeroDate?: string;
  showLessText?: string;
  showMoreText?: string;
  subHeading?: string;
  useLargeMedia?: boolean;
  publishedLabel?: string;
}

const PublicationPageHeroBlock: React.FC<PublicationPageHeroBlockProps> = ({
  byline,
  heading,
  image,
  mediaText,
  publishDate,
  publishedOrUpdatedHeroDate,
  showLessText,
  showMoreText,
  subHeading,
  useLargeMedia,
  publishedLabel,
}) => {
  const backgroundClass = useHeroBackground();
  const theme = useTheme();
  return (
    <div className={backgroundClass}>
      <div
        className={classNames(styles.publicationPageHeroBlock, {
          [styles.withMedia]: image,
          [styles.largeMedia]: useLargeMedia,
          [styles.dark]: theme === "dark",
        })}
      >
        <div className={styles.publicationPageHeroBlockText}>
          {subHeading && <p>{subHeading}</p>}
          {heading && <h1>{heading}</h1>}
          {publishedLabel && (
            <div className={styles.dateGroup}>
              <p>{publishedLabel}</p>
              <p>{publishDate}</p>
            </div>
          )}

          {publishedOrUpdatedHeroDate && (
            <span>
              <IconMS className={styles.icon} name="stylus" size="20px" />
              <p>{publishedOrUpdatedHeroDate}</p>
            </span>
          )}
        </div>
        {image && (
          <div className={styles.publicationPageHeroBlockMedia}>
            <MultiMediaBlock
              image={image}
              byline={byline}
              expandButtonText={showMoreText}
              closeButtonText={showLessText}
              isLargeMedia={true}
              onDarkBackground={theme === "dark"}
              noBorder={true}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default PublicationPageHeroBlock;
